module.exports = __webpack_public_path__ + "img/icon-check.2d75fe7d.svg";